var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 13,
    viewBox: "0 0 15 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6397_11247",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 15,
    height: 13
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.650391,
    width: 14.2222,
    height: 12.8,
    fill: "url(#pattern0_6397_11247)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6397_11247)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -0.771484,
    width: 17.0667,
    height: 12.8,
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_6397_11247",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_6397_11247",
    transform: "matrix(0.01 0 0 0.0111111 0 -0.0555556)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_6397_11247",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAZKADAAQAAAABAAAAZAAAAAAvu95BAAAE10lEQVR4Ae2cT4hVVRzH5ykSCsKsojYDISi40YUtXDQ1QYqYMgsxNwlRRIsoKGbZJLQTWigtElyoICGRCIqgJMIEtXFhi1pEORnVjNgfG8qhNKfPL+YxT+a+e++793fn/e593wO/Oe+ec8/v/H7fD+e+d++Z94aGVKSAFJACUkAKFFOg1W3YwsLCfvqOYI91O0fthRSYZdQbrVbr46TRaUBmGCAYSaqVb5sFyONJbtKALCQNUJuPAgBJ1H6Vj3t58VJAQLyUdPIjIE5CerkREC8lnfwIiJOQXm7SgNz0mkR+linQVds0IK/g5p9lrtRQVgHT1LRNLF2B8DH5U0a8gN1PHKnGIgr8y6CDi9omju8KxM5m4Dmql7EHdqxSSgG70X4NTc+keUkFYgNxcIrqzTQn6sulwARaHs86MxOIOcDRB1TvZjlTf1cFJtHw/a69HR2Jz1M6+h96yRPgwzRMPNSogywFjgIj9xWmVyB2/ofYq1lRqP9/BU7y9yWA5H5Q2xMQm4JVYpe509gBO1bpqsBZevYDwz5Z5S49AzHPQFlDZRM+b8cqyxS4TMteYPy9rCejoRAQ8wmUtVQXsWcwlSUFPuflDmD8tdSU/1VhIDYFUNZTXcGetGOVoetoMAaMO0W1KAXEJgXKMNVVbKsdD3D5ityfBsavZTQoDcQmB8qjVFPYJjsewPIdOY8C4+eyubsAsSCAMkL1GWb1IJWfSPYpYEx7JJ3rTj3PRAT0A+c9h93Kc35DzvmFPOwN3AWGaeIGxJwR2DdUO7Hf7bjhZY78dpHz1555ugKxwAjwS6rdWKGPfeajBmWeGPeQ6zXvWN2BWIAE+gXVONbzjZGND17uEd8+cpyqIs5KgFigBGwbXPZ4pUkbXPYY5EVysxviSkplQCxaAj9H1ZQNLntAmLnBZHmHL3wkfh2re3k7vNC9BAiNyRoTeaeXXGtzLkAO1xCKfSWjmQUYLexYjaCcsJibSWMxKxJchX1UAyifEOPqRsNoJ0eia7DzgaFcIrZH2vGuZN235UjCUTe4Sm0wlYXXNyAWOFCibXBdJ6wx7p/ulBW26Pi+ArGggTJMFWGDy2WDqSiI9ri+A7FAgNLvDS63Daa2sLWvgTKC3cRWuvzIhE/UXsAqEkCYjdjsChK5zVybq8ilMT4RaAv22wpA+YM5tjVGuCoTQajt2J8VQrmL79Eqc2icbwQbw76tAMr3+Hy2cYIpISkgBaSAFBh4BULcqSdRsDfzpHavNp5Xhcy90n9y8BJvkPwISDDaAiIgwRQIFo5WiIAEUyBYOFohAhJMgWDhaIUISDAFgoWjFSIgwRQIFo5WiIAEUyBYOFohAhJMgWDhaIUISDAFgoWjFSIgwRQIFo5WiIAEUyBYOFohAhJMgWDhaIUISDAFgoWjFSIgwRQIFo5WiIDkVsDtp1dzzxjgxMgr5C30aeKPaAbAXjAEviKyAbtg3xXxLgVD0jBTABh7sBueUKRsSQWAsRY7hM17gCkZjoa3FQCGy2Ws7U+1kwKAKXUZcwpDbjoVAErhy1inH712VqDIZcw5BLlLUqCXy1jSeLVVoEDey1gFU8tlmgJZl7G0seqrUAHAjGPTWGeZqXBKuc5SABLrsPcw+1G0OWw8a4z6pYAUkAJSQArUTYH/AOMaebZk/8vQAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIconActive);
export default __webpack_public_path__ + "static/media/filter-icon-active.1cf300d48c9f31f41ad32815790ad3b7.svg";
export { ForwardRef as ReactComponent };